// extracted by mini-css-extract-plugin
module.exports = {"FooterLink":"style-module--FooterLink--1dORZ","link":"style-module--link--23KFr","annotation":"style-module--annotation--1a4Hx"};